var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBonus(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 19,
    viewBox: "0 0 21 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.5 18.9999V15.9999H13.5V14.4999H16.5V11.4999H18V14.4999H21V15.9999H18V18.9999L16.5 18.9999ZM1.11543 16.2499V10.2499H3.05176e-05V8.75L1.07698 3.75H15.4231L16.5 8.75V10.2499H15.3846V13.3846H13.8847V10.2499H9.61541V16.2499H1.11543ZM2.61541 14.75H8.11543V10.2499H2.61541V14.75ZM1.07698 2.24995V0.75H15.4231V2.24995H1.07698ZM1.53078 8.75H14.9693L14.2058 5.24995H2.29426L1.53078 8.75Z",
    fill: "#49A0FF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBonus);
export default __webpack_public_path__ + "static/media/bonus.1a35cbf07fdbc74d952bb90d7b31d647.svg";
export { ForwardRef as ReactComponent };